import styled from 'styled-components';
import Select from 'react-select';
import { Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { Field, Form as Formik } from 'formik';
import { NumericFormat } from 'react-number-format';

export const CustomSelect = styled(Select).attrs({ menuPosition: 'fixed' })`
    & > div {
        border-radius: 14px;
        border-color: ${(props) => (props.error ? '#FF1744' : '#C8C8C8')};
        & > div {
            text-align: start;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &.invalid {
            border-color: red;
            background-color: yellow;
        }
    }
`;

export const CustomControl = styled(Form.Control).attrs({ radius: '14px' })`
    border-radius: 14px;
    text-align: ${(props) => props.textAlign ? props.textAlign : 'center'};
    border: 1px solid ${(props) => (props.error ? '#FF1744' : '#C8C8C8')};
    ${(props) => props.paddings && `padding: ${props.paddings}`}
`;

export const CustomInput = styled.input`
    border-radius: 14px;
    border: 1px solid ${(props) => (props.error ? '#FF1744' : '#C8C8C8')};
    text-align: center;
    background: white !important;
    padding-top: 0.5rem;
    width: 100%;
`;

export const CustomNumberInput = styled(NumericFormat).attrs({
    thousandsGroupStyle: 'thousand',
    thousandSeparator: ','
})`
    border-radius: 14px;
    border: 1px solid ${(props) => (props.error ? '#FF1744' : '#C8C8C8')};
    text-align: center;
    background: white !important;
    padding-top: 0.5rem;
    width: 100%;
`;

export const CustomFormik = styled(Formik)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.1rem;
    width: 100%;

    & > input {
        border-radius: ${(props) => (props.radius ? props.radius : '14')}px;
        border: 1px solid #C8C8C8;
        text-align: center;
        background: white !important;
        padding-top: 0.5rem;
        width: 100%;
    }

    & > button {
        background-color: #FF008C;
        border-radius: ${(props) => (props.radius ? props.radius : '14')}px;
        border: none;
        outline: 0;
        box-shadow: none;
        color: white !important;
        padding: 0.5rem;
        width: 100%;

        &:focus {
            border: none !important;
            outline: 0 !important;
            box-shadow: none !important;
            background-color: #FF008C;
        }
        &:hover {
            background-color: #FF008C;
        }
    }
`;

export const CustomButton = styled(Button)`
    background-color: ${(props) => props.color ? props.color : '#FF008C'};
    border-radius: ${(props) => (props.radius ? props.radius : '14')}px;
    border: none;
    outline: 0;
    box-shadow: none;
    font-size: ${(props) => props.fontSize ? props.fontSize : '12'}pt;    
    white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

    &:focus {
        border: none !important;
        outline: 0 !important;
        box-shadow: none !important;
        background-color: ${(props) => props.color ? props.color : '#FF008C'};
    }
    &:hover {
        background-color: ${(props) => props.color ? props.color : '#FF008C'};
    }
`;

export const TransparentButton = styled(Button)`
    background-color: transparent;
    border: none;
    outline: 0;
    box-shadow: none;
    z-index: 333;

    &:focus {
        border: none !important;
        outline: 0 !important;
        box-shadow: none !important;
        background-color: transparent;
    }
    &:hover {
        background-color: transparent;
    }
`;

export const FormikFieldError = styled.div`
    text-align: right;
    color: #ff1744;
    font-size: 9pt;
    padding-right: 0.3rem;
`;

